import { WSPillProps } from "@wingspanhq/fe-component-library";
import {
  BiometricIdentityVerificationRequest,
  BiometricIdentityVerificationRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import {
  ContextItem,
  RequirementContextType,
  RequirementStatusViewProps,
  RequirementTableItemData
} from "../../../../types";

export const getIdentityVerificationRequirementStatus = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  identityVerification: BiometricIdentityVerificationRequest | undefined,
  contextType: RequirementContextType
): RequirementStatusViewProps => {
  let pill: WSPillProps;
  let secondaryText: string | undefined;

  if (
    identityVerification?.status ===
    BiometricIdentityVerificationRequestStatus.COMPLETE
  ) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };
  } else if (
    identityVerification?.status ===
    BiometricIdentityVerificationRequestStatus.FAILED
  ) {
    pill = {
      theme: "error",
      text: "Failed",
      icon: true
    };
  } else {
    if (contextType === RequirementContextType.Payee) {
      pill = {
        theme: "neutral",
        text: "Awaiting contractor",
        icon: "time"
      };
      secondaryText = "Awaiting contractor completion";
    } else {
      pill = {
        theme: "warning",
        text: "Action required",
        icon: true
      };
      secondaryText = "Awaiting your completion";
    }
  }

  return {
    pill,
    secondaryText
  };
};
